import { render } from "./BraInstorming.vue?vue&type=template&id=e2c6bb70"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BraInstorming.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2c6bb70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2c6bb70', __exports__)) {
    api.reload('e2c6bb70', __exports__)
  }
  
  module.hot.accept("./BraInstorming.vue?vue&type=template&id=e2c6bb70", () => {
    api.rerender('e2c6bb70', render)
  })

}


export default __exports__